import { createRemoteJWKSet, jwtVerify } from 'jose';
import _ from 'lodash';
import { reassembleChunks, readChunkedCookie } from '../../helpers/cookies';

const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return undefined;
};

const getChunkedCookie = cookieName => readChunkedCookie(cookieName, getCookie);

const getToken = () => getChunkedCookie('id_token') || getChunkedCookie('CF_Authorization');

const getLoginUrl = (origin, clientId) => `${origin}/af/sso/new/login?client_id=${clientId}&redirect_uri=${encodeURIComponent(`${origin}/af/sso/new/authorize`)}`;

const getLogoutUrl = (origin, clientId, postLogoutRedirectUri) => {
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.append('client_id', clientId);
  if (postLogoutRedirectUri) {
    urlSearchParams.append('post_logout_redirect_uri', postLogoutRedirectUri);
  }
  return `${origin}/af/sso/new/logout?${urlSearchParams.toString()}`;
};

const getUser = async (token, origin) => {
  const jwks = createRemoteJWKSet(new URL(`${origin}/af/sso/.well-known/jwks.json`));

  return jwtVerify(token, jwks).then(d => d.payload).catch(() => null);
};

const isAuthenticated = async (token, origin) => {
  if (!token) {
    return null;
  }

  const user = await getUser(token, origin);

  if (!!(user) && (user.roles.includes('admin') || user.roles.includes('hello'))) {
    return {
      readWorkspaces: user.readWorkspaces,
      writeWorkspaces: user.writeWorkspaces,
      roles: user.roles
    };
  }
  return null;
};

const canUseCRM = roles => _.intersection(roles, ['admin', 'crm']).length;

const canUseCollab = roles => _.intersection(roles, ['admin', 'collaborator']).length;

export { reassembleChunks, getChunkedCookie, getUser, isAuthenticated, canUseCRM, canUseCollab, getLoginUrl, getLogoutUrl, getToken };
